import { DeleteSearchConditionsApi } from "@/features/accounts/shared/services/delete-search-conditions-api";
import { DeleteSearchConditionsDeleteRequestModel } from "@/features/accounts/shared/services/delete-search-conditions-model";

/// 検索条件削除処理
export class DeleteSearchConditionsService {
  private deleteSearchConditionsApi = new DeleteSearchConditionsApi();

  /**
   * 検索条件削除API実行
   */
  public async deleteSearchConditions(param: DeleteSearchConditionsDeleteRequestModel) {
    return await this.deleteSearchConditionsApi.deleteSearchConditions(param);
  }
}
